module.exports = __webpack_public_path__ + "static/media/dummy_provider_logo.ed9efac7.svg";